module.exports = __webpack_public_path__ + "img/icon-login-aasp.b1e6b6c0.svg";